<template>
  <div class="home">
    <div class="top">
      <img :src="login" alt="" />
      <img :src="login2" alt="" />
      <img :src="login3" alt="" />
      <!--      <div class="logo"></div>-->
      <div class="login_text">
        <p>您好，欢迎使用</p>
        <p>碳中和数字化管控系统</p>
      </div>
    </div>
    <div class="footer">
      <div>
        <van-form>
          <div class="formItem styleborder">
            <span></span>
            <i class="one"></i>
            <van-field
              id="input"
              v-model="userId"
              class="input"
              placeholder="请输入用户id"
            />
          </div>
          <div class="formItem styleborder">
            <span></span>

            <i class="two"></i>
            <van-field
              v-model="userCode"
              class="input"
              placeholder="请输入账号"
            />
          </div>
          <div class="formItem styleborder">
            <span></span>
            <i class="three"></i>
            <van-field
              v-model="passWord"
              class="input"
              placeholder="请输入密码"
              type="password"
            />
          </div>
          <div class="formItem onbutton">
            <button class="submit" type="button" @click="login1()">登录</button>
          </div>
        </van-form>
      </div>
    </div>
  </div>
</template>

<script>
import { login } from "@/api/login";
import { mapMutations } from "vuex";

export default {
  name: "Home",
  data() {
    return {
      userId: "",
      userCode: "",
      passWord: "",
      login: require("../assets/login/login1.png"),
      login2: require("../assets/login/login2.png"),
      login3: require("../assets/login/login3.png"),
    };
  },
  mounted() {
    (this.userId = ""), (this.userCode = ""), (this.passWord = "");
  },
  methods: {
    ...mapMutations(["setUser"]),
    login1() {
      if (this.userId === "" || this.userCode === "" || this.passWord === "") {
        this.$toast.fail("用户信息验证失败!");
      } else {
        this.$toast.allowMultiple();
        window.localStorage.setItem("tenantId", this.userId);
        window.localStorage.setItem("userId", this.userCode);
        login(this.userId, this.userCode, this.passWord)
          .then((res) => {
            this.setUser(res.data);
            this.$toast.loading({
              message: "登陆中...",
              forbidClick: true,
            });
            setTimeout(() => {
              this.$router.push({
                path: "/",
              });
            }, 1500);
          })
          .catch((err) => {
            // 处理 getJSON 和 前一个回调函数运行时发生的错误
            this.$toast.fail(err.response.data.error_description);
          });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.home {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: #4946d9;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  .top {
    width: 100%;
    height: 10rem;
    position: relative;

    .login_text {
      color: #ffffff;
      font-size: 20px;
      font-weight: 800;
      position: absolute;
      left: 8%;
      top: 42%;
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      flex-direction: column;
      letter-spacing: 2px;
      font-family: "黑体", serif;

      & > p {
        line-height: 55px;
      }
    }

    & > img {
      position: absolute;

      &:nth-child(1) {
        left: 64.5%;
        top: 18%;
        width: 18%;
        height: 11%;
        z-index: 1;
        animation: animate-class infinite 2s ease-in-out;
        animation-direction: alternate;
        -webkit-animation-direction: alternate;
      }

      &:nth-child(2) {
        left: 0;
        top: 0;
        width: 100%;
        height: auto;
        z-index: 0;
      }

      &:nth-child(3) {
        left: 62.5%;
        top: 0%;
        width: 22%;
        height: 30%;
        z-index: 2;
      }
    }

    .logo {
      width: 160px;
      height: 60px;
      background: url(../assets/logo.png) no-repeat;
      background-size: 72%;
      margin: -0.8rem auto 0 auto;
      position: relative;
      top: 23%;
      left: -22%;
    }
  }

  .footer {
    padding: 0 0.8rem;
    margin-top: -80px;
    //height: 7.7rem;
    & > div {
      width: 100%;
      height: 100%;
      background-color: rgba(101, 117, 255, 1);
      border-radius: 10px;
      padding: 30px 15px;
      box-sizing: border-box;

      .van-form {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
      }
    }

    .formItem {
      width: 100%;
      // height: 45px;
      // line-height: 40px;
      position: relative;
      margin: 10px 0;

      &.styleborder {
        position: relative;

        &:before {
          position: absolute;
          content: "";
          width: 85%;
          height: 0.02rem;
          left: 6%;
          top: 96.8%;
          background-color: #b9b9b9;
          z-index: 3;
        }
      }

      &.onbutton {
        width: 89%;
      }
    }

    &:nth-child(4) {
      border-bottom: none;
    }

    button {
      border: none;
      //background: #5b86e5;
      width: 100%;
      height: 45px;
      color: #fff;
      font-size: 14px;
      border-radius: 5px;
      margin-top: 10px;
      margin-bottom: 10px;
    }

    a {
      color: #333;
      font-size: 14px;
    }

    .input {
      border: 0;
      font-size: 14px;
      width: 100%;
      height: 100%;
      padding-left: 50px;
      // padding-top: 14px;
      background: rgba(101, 117, 255, 1);
      box-sizing: border-box;
      border-radius: 5px;
    }

    .submit {
      background: rgba(74, 125, 255, 1);
    }

    input::-webkit-input-placeholder {
      color: #cccccc;
    }

    .one,
    .two,
    .three {
      display: block;
      position: absolute;
      width: 24px;
      height: 24px;
      background: url(../assets/login/id.png) no-repeat;
      background-size: 14px;
      top: 55%;
      margin-top: -10px;
      z-index: 100;
      left: 8%;
    }

    .two {
      background: url(../assets/login/uses.png) no-repeat;
      background-size: 14px;
    }

    .three {
      background: url(../assets/login/pass.png) no-repeat;
      background-size: 14px;
    }
  }
}

@-webkit-keyframes animate-class {
  0% {
    top: 18%;
  }

  100% {
    top: 12%;
  }
}

@keyframes animate-class {
  0% {
    top: 18%;
  }

  100% {
    top: 12%;
  }
}

#input /deep/ .van-field__control {
  color: #ffffff !important;
}
</style>
